<template>
  <div>
    <div v-if="form" style="text-align: right;" dir="rtl">
      <div>
        <p class="bold">Owner</p>
        <select v-model="form.data.owner_schedule.fields.owner.value" dir="rtl">
          <option v-for="owner in $settings.get({ path: 'owners' })" :key="owner.name">{{owner.name}}</option>
        </select>
      </div>
      <div>
        <p class="bold">Group Name</p>
        <select v-model="form.data.owner_schedule.fields.group_name.value" dir="rtl">
          <option>Blue</option>
          <option>Red</option>
        </select>
      </div>
      <div>
        <p class="bold">Timing</p>
        <input class="outlined" v-model="form.data.owner_schedule.fields.timing.value">
      </div>
      <div>
        <p class="bold">Day</p>
        <select v-model="form.data.owner_schedule.fields.week_day.value" dir="rtl">
          <option>Sunday</option>
          <option>Monday</option>
          <option>Tuesday</option>
          <option>Wednesday</option>
          <option>Thursday</option>
        </select>
      </div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  props: ['payload'],
  name: 'admin-owner-schedule-form',
  data () {
    return {
      is_loading: false,
      form: undefined
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: ''
        })
        return
      }
      this.$network_utils.getOwnerSchedule({ id: this.payload.data.id }).then(response => {
        this.setForm(response)
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        owner_schedule: {
          fields: {
            owner: {
              value: form_data.owner,
              has_error: false,
              validations: []
            },
            group_name: {
              value: form_data.group_name,
              has_error: false,
              validations: []
            },
            timing: {
              value: form_data.timing,
              has_error: false,
              validations: []
            },
            week_day: {
              value: form_data.week_day,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/owners_schedule/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
